import {
  cn
} from "./chunk-LJ5F4WFH.js";

// src/Label/Label.tsx
import React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
var Label = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React.createElement(
  LabelPrimitive.Root,
  {
    ref,
    className: cn(
      "inline-flex text-left text-body-2 leading-none text-neutral-primary peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      className
    ),
    ...props
  }
));
Label.displayName = LabelPrimitive.Root.displayName;

export {
  Label
};
//# sourceMappingURL=chunk-52NXO4YC.js.map